document.documentElement.classList.remove('no-js');

/* ========================================================================== 
   Header scroll state
   ========================================================================== */
(function () {
  var header = document.querySelector('[data-header]');
  if (!header) return;
  function onScroll() {
    header.classList.toggle('is-scrolled', window.scrollY > 12);
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();

/* ========================================================================== 
   Mobile nav
   ========================================================================== */
(function () {
  var toggle = document.querySelector('[data-mobile-nav-toggle]');
  var nav = document.querySelector('[data-mobile-nav]');
  if (!toggle || !nav) return;

  function close() {
    nav.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
  }
  function open() {
    nav.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
  }
  toggle.addEventListener('click', function () {
    nav.classList.contains('is-open') ? close() : open();
  });
  nav.querySelectorAll('a').forEach(function (a) {
    a.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();

/* ========================================================================== 
   Cart drawer (Ajax Cart API + Section Rendering API)
   ========================================================================== */
var MystovaCart = (function () {
  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');
  var cartCountEls = document.querySelectorAll('[data-cart-count]');

  function refreshDrawerMarkup() {
    var url = window.location.pathname + window.location.search;
    var sep = url.indexOf('?') === -1 ? '?' : '&';
    return fetch(url + sep + 'sections=cart-drawer')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        if (newDrawer && drawer) {
          drawer.innerHTML = newDrawer.innerHTML;
          bindDrawerEvents();
        }
      });
  }

  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
      el.classList.remove('is-bumping');
      void el.offsetWidth;
      el.classList.add('is-bumping');
    });
  }

  function open() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function bindDrawerEvents() {
    drawer.querySelectorAll('[data-cart-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    drawer.querySelectorAll('[data-cart-line]').forEach(function (line) {
      var key = line.getAttribute('data-line-key');
      var decrease = line.querySelector('[data-qty-decrease]');
      var increase = line.querySelector('[data-qty-increase]');
      var remove = line.querySelector('[data-cart-remove]');
      var qtyValue = line.querySelector('[data-qty-value]');

      if (decrease) {
        decrease.addEventListener('click', function () {
          var qty = Math.max(0, parseInt(qtyValue.textContent, 10) - 1);
          changeLine(key, qty);
        });
      }
      if (increase) {
        increase.addEventListener('click', function () {
          var qty = parseInt(qtyValue.textContent, 10) + 1;
          changeLine(key, qty);
        });
      }
      if (remove) {
        remove.addEventListener('click', function () {
          changeLine(key, 0);
        });
      }
    });
  }

  function changeLine(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshDrawerMarkup();
      });
  }

  function addItem(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: quantity || 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (e) { throw e; });
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        return refreshDrawerMarkup();
      })
      .then(function () {
        open();
      });
  }

  if (overlay) overlay.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
  document.querySelectorAll('[data-cart-toggle]').forEach(function (btn) {
    btn.addEventListener('click', open);
  });
  bindDrawerEvents();

  return { open: open, close: close, addItem: addItem, updateCartCount: updateCartCount };
})();

/* ========================================================================== 
   Product form (main add-to-cart) + quick-add buttons
   ========================================================================== */
document.addEventListener('submit', function (e) {
  var form = e.target.closest('[data-product-form]');
  if (!form) return;
  e.preventDefault();

  var variantId = form.querySelector('[name="id"]').value;
  var qtyInput = form.querySelector('[name="quantity"]');
  var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
  var submitBtn = form.querySelector('[data-add-to-bag]');
  var label = submitBtn ? submitBtn.querySelector('[data-add-label]') : null;

  if (submitBtn) submitBtn.disabled = true;

  MystovaCart.addItem(variantId, quantity)
    .then(function () {
      if (label) {
        var original = label.textContent;
        label.textContent = 'Added to Bag';
        setTimeout(function () { label.textContent = original; }, 1800);
      }
    })
    .finally(function () {
      if (submitBtn) submitBtn.disabled = false;
    });
});

document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-quick-add]');
  if (!btn) return;
  e.preventDefault();
  var variantId = btn.getAttribute('data-variant-id');
  if (!variantId) return;
  btn.disabled = true;
  MystovaCart.addItem(variantId, 1).finally(function () {
    btn.disabled = false;
  });
});

/* ========================================================================== 
   Product form quantity stepper (product detail page)
   ========================================================================== */
document.addEventListener('click', function (e) {
  var decrease = e.target.closest('[data-form-qty-decrease]');
  var increase = e.target.closest('[data-form-qty-increase]');
  if (!decrease && !increase) return;
  var wrapper = (decrease || increase).closest('[data-qty-selector]');
  if (!wrapper) return;
  var input = wrapper.querySelector('input[name="quantity"]');
  var display = wrapper.querySelector('[data-qty-value]');
  var value = parseInt(input.value, 10) || 1;
  value = decrease ? Math.max(1, value - 1) : value + 1;
  input.value = value;
  if (display) display.textContent = value;
});

/* ========================================================================== 
   Scroll reveal animations (respects prefers-reduced-motion)
   ========================================================================== */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduceMotion) {
    document.querySelectorAll('.reveal, .reveal-item').forEach(function (el) {
      el.classList.add('is-visible');
    });
    document.querySelectorAll('.reveal-group').forEach(function (el) {
      el.classList.add('is-visible');
    });
    return;
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
  );

  document.querySelectorAll('.reveal').forEach(function (el) {
    observer.observe(el);
  });

  document.querySelectorAll('.reveal-group').forEach(function (group) {
    var items = group.querySelectorAll('.reveal-item');
    var groupObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          items.forEach(function (item, i) {
            // Cap the stagger so long grids (collections, 20+ items) still
            // settle quickly instead of trickling in for seconds.
            var delay = Math.min(i * 45, 360);
            setTimeout(function () { item.classList.add('is-visible'); }, delay);
          });
          groupObserver.unobserve(entry.target);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );
    groupObserver.observe(group);
  });
})();

/* ========================================================================== 
   Word-wipe text reveal for headings (respects prefers-reduced-motion)
   ========================================================================== */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) return;

  var targets = document.querySelectorAll('.h2, .hero__title, .eyebrow');
  if (!targets.length) return;

  targets.forEach(function (el) {
    var text = el.textContent.trim();
    if (!text) return;
    var words = text.split(/\s+/);

    var wrap = document.createElement('span');
    wrap.className = 'split-text';
    wrap.setAttribute('aria-hidden', 'true');

    words.forEach(function (word, i) {
      var outer = document.createElement('span');
      outer.className = 'split-word';
      var inner = document.createElement('span');
      inner.className = 'split-word-inner';
      inner.style.transitionDelay = (i * 0.035).toFixed(3) + 's';
      inner.textContent = word;
      outer.appendChild(inner);
      wrap.appendChild(outer);
      if (i < words.length - 1) wrap.appendChild(document.createTextNode(' '));
    });

    el.setAttribute('aria-label', text);
    el.textContent = '';
    el.appendChild(wrap);
  });

  var splitObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-split-visible');
        splitObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
  );

  targets.forEach(function (el) { splitObserver.observe(el); });
})();

/* ========================================================================== 
   FAQ accordion
   ========================================================================== */
(function () {
  document.addEventListener('click', function (e) {
    var question = e.target.closest('[data-faq-question]');
    if (!question) return;
    var item = question.closest('[data-faq-item]');
    var isOpen = item.classList.contains('is-open');

    item.closest('[data-faq-list]')
      .querySelectorAll('[data-faq-item]')
      .forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
          other.querySelector('[data-faq-question]').setAttribute('aria-expanded', 'false');
        }
      });

    item.classList.toggle('is-open', !isOpen);
    question.setAttribute('aria-expanded', String(!isOpen));
  });
})();

/* ========================================================================== 
   Animated count-up (stats bar)
   ========================================================================== */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var counters = document.querySelectorAll('[data-count-to]');
  if (!counters.length) return;

  function animateCount(el) {
    var target = parseInt(el.getAttribute('data-count-to'), 10) || 0;
    var suffix = el.getAttribute('data-count-suffix') || '';
    if (reduceMotion) {
      el.textContent = target + suffix;
      return;
    }
    var duration = 1400;
    var start = null;
    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = Math.floor(eased * target) + suffix;
      if (progress < 1) requestAnimationFrame(step);
      else el.textContent = target + suffix;
    }
    requestAnimationFrame(step);
  }

  var counterObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        animateCount(entry.target);
        counterObserver.unobserve(entry.target);
      });
    },
    { threshold: 0.4 }
  );
  counters.forEach(function (el) { counterObserver.observe(el); });
})();
